module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "店铺所属大区"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-cascader', {
    attrs: {
      "placeholder": "所属大区",
      "options": this.area.list,
      "props": {
        checkStrictly: true
      },
      "clearable": ""
    },
    on: {
      "change": _vm.handleOfficeChange
    },
    model: {
      value: (_vm.selected_office_area_id),
      callback: function($$v) {
        _vm.selected_office_area_id = $$v
      },
      expression: "selected_office_area_id"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "店铺标签"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-cascader', {
    attrs: {
      "placeholder": "选择标签",
      "options": this.tag.list,
      "props": {
        value: 'tag_id',
        label: 'tag_name'
      },
      "clearable": ""
    },
    on: {
      "change": _vm.TagChangeAction
    },
    model: {
      value: (_vm.form.dis_tag_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "dis_tag_id", $$v)
      },
      expression: "form.dis_tag_id"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "店铺英克ID"
    }
  }, [_c('div', [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "多个店铺ID之间使用英文逗号 ',' 分隔"
    },
    model: {
      value: (_vm.form.inca_ids),
      callback: function($$v) {
        _vm.$set(_vm.form, "inca_ids", $$v)
      },
      expression: "form.inca_ids"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品货号"
    }
  }, [_c('div', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.item_bn),
      callback: function($$v) {
        _vm.$set(_vm.form, "item_bn", $$v)
      },
      expression: "form.item_bn"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#f00"
    }
  }, [_vm._v("一次只能设置一个商品的区域划线价")])], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品区域划线价"
    }
  }, [_c('div', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "required": "",
      "min": "0"
    },
    model: {
      value: (_vm.form.area_market_price),
      callback: function($$v) {
        _vm.$set(_vm.form, "area_market_price", $$v)
      },
      expression: "form.area_market_price"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#f00"
    }
  }, [_vm._v("（单位：元）设置为 0 时则取消该商品的区域划线价")])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "section-footer with-border content-center"
  }, [_c('el-button', {
    attrs: {
      "size": "large"
    },
    on: {
      "click": _vm.cancelSubmit
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.setAreaMarketPrice
    }
  }, [_vm._v(_vm._s(_vm.submitLoading ? '提交中' :
    '保存') + "\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-202146b2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-202146b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/storeshop/areaMarketPrice/add.vue
// module id = 2528
// module chunks = 0